import React from 'react';
import { Link } from 'react-router-dom';

import { linkedin, github } from '../assets';

const Contact = () => (
  <section className="pt-[100px] pb-[70px]">
    <div className="wrapper">
      <div className="bg-contact dark:bg-black3 dark:bg-none bg-right min-h-[300px] md:min-h-[428px]
        pt-[60px] pb-[40px] md:pt-[80px] pl-[30px] pr-[30px] md:pl-[40px] xl:pl-[150px] md:pr-[40px] rounded-[20px]"
      >
        <div className="section-title section-title5 dark:before:bg-primaryOrange/25">
          <h2 className="relative text-primaryBlack dark:text-white
          text-[32px] leading-[40px] md:text-[50px] md:leading-[60px] lg:text-[67px] lg:leading-[86px] font-extrabold md:font-bold"
          >
            Have a project idea to collaborate on?
          </h2>
        </div>
        <Link
          to="/contact"
          type="button"
          className="button button-white mt-8"
        >
          Contact Me
        </Link>
      </div>
      <div className="flex gap-8 justify-center pt-[50px]">
        <a
          href="https://www.linkedin.com/in/nenad-baltic"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={linkedin}
            alt="linkedin"
            className="w-[25px] grayscale hover:grayscale-0 hover:scale-110 transition duration-300"
          />
        </a>
        <a
          href="https://www.github.com/nenadbaltic"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={github}
            alt="github"
            className="w-[25px] grayscale hover:grayscale-0 hover:scale-110 transition duration-300"
          />
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
